/**
 * 로그인 완료 측정 — GA4 login · dataLayer gb_login_completed.
 *
 * 로그인 화면은 shopify.com 이라 우리 코드가 돌지 않는다. 그래서 piyonna.com 으로 돌아온 페이지에서 기록한다.
 * 로그인인지는 snippets/tracking-bootstrap.liquid 가 신원 전환으로 판정해 gb_login_pending 에 남긴다.
 * 표시로 미루는 이유: 이 파일이 돌기 전에 떠나도 다음 페이지에서 보낼 수 있다(MAX_AGE_MS 안).
 *
 * 광고 전환은 보내지 않는다. 광고의 표준 전환은 가입이고, 가입 판정은 tracking-signup-conversion.js 가 한다.
 * 동의: 전부 analytics 안에서 돈다. 광고 클릭 ID 는 marketing 동의가 있을 때만 붙인다.
 */
(function () {
  'use strict';

  var cfg = window.GBTrackConfig || {};
  if (!cfg.enabled || cfg.design_mode) return;
  if (!window.GBConsent) {
    console.warn('[GBTrack:login-conv] GBConsent 미로드 — 로그인 측정 보류');
    return;
  }

  var PENDING_KEY = 'gb_login_pending';
  var MAX_AGE_MS = 30 * 60 * 1000; // 이보다 오래된 표시는 버린다
  var liq = cfg.liquid_context || {};
  var nowUid = liq.customer_id != null ? String(liq.customer_id) : ''; // 부트스트랩의 nowUid 와 같은 값

  function readPending() {
    try {
      var raw = localStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || !p.uid) return null;
      // 이 페이지 고객의 표시가 아니면(로그아웃한 페이지면 모두) 버린다 — 이전 고객 ID 를 싣지 않는다.
      if (String(p.uid) !== nowUid || Date.now() - (p.ts || 0) > MAX_AGE_MS) {
        localStorage.removeItem(PENDING_KEY);
        return null;
      }
      return p;
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {
      /* noop */
    }
  }

  /** 광고 클릭 ID. sessionStorage(gb_attr_click)가 비어 있으면(로그인 왕복 뒤 새 탭) 쿠키 _fbc · _gcl_aw 에서 꺼낸다 */
  function collectAttribution() {
    var out = {};
    try {
      var click = JSON.parse(sessionStorage.getItem('gb_attr_click') || '{}') || {};
      Object.keys(click).forEach(function (k) {
        if (click[k]) out[k] = click[k];
      });
    } catch (e) {
      /* noop */
    }
    try {
      if (!out.fbclid) {
        var fbc = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
        // _fbc 형식: fb.1.<timestamp>.<fbclid>
        if (fbc) out.fbclid = decodeURIComponent(fbc[1]).split('.').slice(3).join('.');
      }
      if (!out.gclid) {
        var gcl = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]+)/);
        // _gcl_aw 형식: GCL.<timestamp>.<gclid>
        if (gcl) out.gclid = decodeURIComponent(gcl[1]).split('.').slice(2).join('.');
      }
    } catch (e) {
      /* noop */
    }
    return out;
  }

  /**
   * 상관용 id — GA4 기록과 나중의 서버 전송을 잇는다.
   * 광고 중복제거(event_id)에는 쓰지 않는다. 브라우저가 감지한 시각(초)이 들어 있어 서버 쪽 값과 어긋나면
   * 전환이 두 번 잡힌다. 광고 중복제거 id 는 'gbsignup.<고객ID>' 다(tracking-signup-conversion.js).
   */
  function buildCorrelationId(pending) {
    return 'gblogin.' + pending.uid + '.' + Math.floor((pending.ts || Date.now()) / 1000);
  }

  function record(pending) {
    var uid = String(pending.uid);
    var corrId = buildCorrelationId(pending);
    var attr = window.GBConsent.isAllowed('marketing') ? collectAttribution() : {};
    var sent = [];

    // 1) GA4 권장 이벤트 login. 측정 전용 — 광고 전환에 연결하지 않는다.
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'login', {
          method: 'shopify_customer_account',
          gb_login_kind: pending.kind,
          gb_correlation_id: corrId,
        });
        sent.push('gtag');
      } catch (e) {
        if (window.GBTrack && window.GBTrack.logError) window.GBTrack.logError('login-conv:gtag', e);
      }
    }

    // 2) GTM. gtag 가 아직 없어도 dataLayer 큐에는 쌓인다.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'gb_login_completed',
        gb_login_kind: pending.kind,
        gb_correlation_id: corrId,
        user_id: uid,
        gb_attr_fbclid: attr.fbclid,
        gb_attr_gclid: attr.gclid,
        gb_attr_ttclid: attr.ttclid,
      });
      sent.push('gtm');
    } catch (e) {
      /* noop */
    }

    // dataLayer 는 큐라 실패하지 않는다. 기록이 남았다고 보고 표시를 지운다.
    clearPending();

    if (window.GBTrack && window.GBTrack.isDebug && window.GBTrack.isDebug()) {
      console.info('[GBTrack:login-conv] recorded', { corrId: corrId, kind: pending.kind, sent: sent, attr: attr });
    }
  }

  window.GBConsent.whenAllowed('analytics', function () {
    var pending = readPending();
    if (pending) record(pending);
  });
})();
